import { useLocation } from "react-router-dom"

import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

export function Toaster() {
  const { toasts } = useToast()

  // BLU-631: mirror the sonner reposition (see components/ui/sonner.tsx). A few
  // station surfaces still emit legacy radix toasts via useToast (e.g. the
  // catcher redo-created confirmation), which otherwise render bottom-right over
  // the station's sticky Accept/Redo action bar. On production-app routes move
  // the viewport to top-center so toasts can never cover a primary action.
  const { pathname } = useLocation()
  const isProductionSurface =
    pathname === "/production" || pathname.startsWith("/production/")

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport
        className={
          isProductionSurface
            ? "flex-col sm:left-1/2 sm:right-auto sm:top-0 sm:bottom-auto sm:-translate-x-1/2"
            : undefined
        }
      />
    </ToastProvider>
  )
}
